module.exports = __webpack_public_path__ + "static/media/happy120+.76cef554.gif";